/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyerChatLazy_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatRespContainer_viewer">;
    readonly " $refType": "BuyerChatLazy_viewer";
};
export type BuyerChatLazy_viewer$data = BuyerChatLazy_viewer;
export type BuyerChatLazy_viewer$key = {
    readonly " $data"?: BuyerChatLazy_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatLazy_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerChatLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerChatRespContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '132e477f3447b4e677ad6828d4ccd431';
export default node;
